const isNumber = (data) => {
  const key = 'isNumber'
  const { value } = data
  const isNumeric = !isNaN(value) ? true : false
  const error = isNumeric ? false : key
  return error ? { error, data } : false
}

export default isNumber
